import { LessonDataI } from "@/components/quiz/typesAndEnums";
import { Button } from "@/components/ui/button";
import EliteVideoPlayer from "@/components/video/EliteVideoPlayer/EliteVideoPlayer";
import QashqoolNativeApp from "@/components/video/QashqoolNativeApp";
import { LessonScreenI } from "@/hooks/types";
import { isElectron, isQashqoolMobile, isXvast } from "@/scripts/environmentDetector";
import { ArrowLeft } from "lucide-react";
import LessonExpired from "./LessonExpired";

const LessonVideo = ({
  lessonData,
  videoId,
  setScreenContent,
}: {
  lessonData: LessonDataI;
  videoId: string;
  setScreenContent: React.Dispatch<React.SetStateAction<LessonScreenI>>;
}) => {
  let isExpired = true;

  const isAuthor = !!lessonData.is_author;
  const isPurchased = lessonData.is_purchased;
  const unlimitedViews =
    lessonData.remaining_views === -1 || lessonData.lesson_videos.length > 1;
  const unlimitedExpiryDate = lessonData.expiry_date === -1;
  const isViewsExpired = lessonData.remaining_views < 1 && !unlimitedViews;
  const isDateExpired =
    !unlimitedExpiryDate && lessonData.expiry_date < Date.now();

  if (!isViewsExpired && !isDateExpired && isPurchased) isExpired = false;
  if (isAuthor) isExpired = false;

  const isProtected =
    lessonData.xvast_protection &&
    !isXvast() &&
    !(isElectron() || isQashqoolMobile())

  if (isExpired) return <LessonExpired lessonData={lessonData} />;

  if (isProtected) return <QashqoolNativeApp />;

  return (
    <div className="pt-2 pe-4 ps-4 pb-4">
      <Button
        className="bg-primary rounded-2xl w-fit"
        onClick={() =>
          setScreenContent((prev: LessonScreenI) => ({
            ...prev,
            elementId: "",
          }))
        }
      >
        <ArrowLeft className="text-white size-5 mx-3" />
      </Button>
      <div key={videoId}>
        <h2 className="py-2 px-3 text-3xl my-2 mx-auto text-center bg-blue-50 border border-blue-400 text-blue-600 w-full rounded-2xl">
          {
            lessonData.lesson_videos.find((item) => item.video_id === videoId)
              .video_title
          }
        </h2>
        <div className="w-full bg-black rounded-2xl overflow-hidden">
          <EliteVideoPlayer vidId={videoId} lessonData={lessonData} />
        </div>
      </div>
    </div>
  );
};

export default LessonVideo;
